/**
* avatar component for the left side menu
*
* Created by Tom on 25/05/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { ActionCreator } from '../../actions/'


// style import
import './style.scss'


class Avatar extends Component {

    _updateProfileClick(e) {
        const { goToRoute, setOpenLeftMenu } = this.props
        // do not refresh page
        e.preventDefault();
        e.stopPropagation();
        // go to route
        goToRoute('/account')
        setOpenLeftMenu(false)
    }

    render() {

        const name = this.props.profile['first_name']

        return (
            <div className="avatar">

                {/* container for the avatar icon, name & link */}
                <div className="avatar__info-container">
                    <div className="avatar__info-container__profile-container">
                        <p className="avatar__info-container__avatar-name">{name}</p>
                        <a href="" className="avatar__info-container__profile-container__update"
                            onClick={::this._updateProfileClick}>
                            Update my profile
                        </a>
                    </div>
                </div>

            </div>
        )
    }
}

// define the prop types
Avatar.propTypes = {
    goToRoute: PropTypes.func.isRequired,
    pathname: PropTypes.string,
    profile: PropTypes.object,
    setOpenLeftMenu: PropTypes.func.isRequired,
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        // get the name from store
        pathname: state.router.location.pathname,
        profile: state.profileState.data,
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        goToRoute: action.goToRoute,
        setOpenLeftMenu: action.setOpenLeftMenu
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Avatar)



// WEBPACK FOOTER //
// ./src/components/Avatar/index.js